import { FT5_OFFERS_ARTICLE_OPTION_CHANGE, trackClickAction } from '../../_common/client/offers-tracking';
import { BaseComponent2 } from '../../_common/client/base-component2';
import { notNullQuerySelector } from '../../_common/client/dom-helper';

export class OffersDeliveryComponent extends BaseComponent2 {
    public static AVAILABILITY_MESSAGE_SELECTOR = '.js_of_availabilityMessage_Feature';
    public static AVAILABILITY_MESSAGE_SLOW_SELECTOR = '.js_of_availabilityMessageSlow_Feature';
    public readonly rootSelector = '.js_of_offers-delivery';

    public async onReloadComponentEvent(): Promise<void> {
        this.registerClickTracking();
        this.processDeliverySlowFeature();
    }

    public registerClickTracking(): void {
        const moduleElement = this.getRootElement();
        const shippingLinkExists = this.getRootElement().querySelector('.js_of_offers-delivery__shippingLink') != null;
        if (shippingLinkExists) {
            o_util.event.delegate(moduleElement, 'click', '.js_of_offers-delivery__shippingLink', () => {
                trackClickAction(this.getVariationId());
            });
        }
    }

    private getVariationId(): string {
        return this.getRootElement().getAttribute('data-variation-id') ?? '';
    }

    private processDeliverySlowFeature() {
        if (this.getRootElement().dataset.deliveryOnDemand === 'true') {
            o_global.eventQBus.on(FT5_OFFERS_ARTICLE_OPTION_CHANGE, () => {
                const dataVariationSelectorPrefix = `[data-variation-id="${this.getVariationId()}"]`;
                const dataArticleOptionSelector = '[data-delivery-within48h="false"]';
                const selectedServicesChangeDeliveryMessageToSlow = Array.from(
                    document.querySelectorAll<HTMLInputElement>(`${dataVariationSelectorPrefix} ${dataArticleOptionSelector}`)
                ).filter(service => service.checked).length;

                this.switchShownDeliveryMessage(selectedServicesChangeDeliveryMessageToSlow > 0);
            });
        } else if (this.getRootElement().dataset.deliveryOnDemand === 'false') {
            const availabilityMessageSlowElement = this.getChildElement(OffersDeliveryComponent.AVAILABILITY_MESSAGE_SLOW_SELECTOR);
            if (availabilityMessageSlowElement?.textContent?.trim()) {
                this.switchShownDeliveryMessage(true);
            }
        }
    }

    private switchShownDeliveryMessage(showSlowMessage: boolean) {
        const hiddenCssClass = 'pl_hidden';
        const availabilityMessageElement = notNullQuerySelector(OffersDeliveryComponent.AVAILABILITY_MESSAGE_SELECTOR, this.rootElement);
        const availabilityMessageSlowElement = notNullQuerySelector(
            OffersDeliveryComponent.AVAILABILITY_MESSAGE_SLOW_SELECTOR,
            this.rootElement
        );

        if (showSlowMessage && availabilityMessageSlowElement.classList.contains(hiddenCssClass)) {
            availabilityMessageElement.classList.add(hiddenCssClass);
            availabilityMessageSlowElement.classList.remove(hiddenCssClass);
        } else if (!showSlowMessage && availabilityMessageElement.classList.contains(hiddenCssClass)) {
            availabilityMessageElement.classList.remove(hiddenCssClass);
            availabilityMessageSlowElement.classList.add(hiddenCssClass);
        }
    }
}
